var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"energy-legend"},_vm._l((_vm.legendItems),function(item){return _c('div',{key:item.class,staticClass:"energy-legend__item"},[_c('div',{class:[
        'energy-legend__label',
        `energy-legend__label--${item.class
          .toLowerCase()
          .replace('+', 'plus')}`,
      ]},[_vm._v("\n      "+_vm._s(item.class)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"legend-text"},[_vm._v(_vm._s(item.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }